/*
* @Description: In User Settings Edit
* @Author: your name
* @Date: 2019-08-09 16:41:54
* @LastEditTime: 2019-12-19 10:53:49
* @LastEditTime: 2019-09-09 11:43:43
* @LastEditors: Please set LastEditors
*/

export default {
  general: {
    save: 'บันทึก',
    autosaved: 'บันทึกอัตโนมัติ',
    back_to: 'กลับไปยัง',
    by: 'โดย',
    chat: 'การพูดคุย',
    completed: 'เสร็จ',
    canceled: 'Dibatalkan',
    component: 'Komponen',
    confirm: 'Sahkan',
    course: 'Kursus',
    date: 'Tarikh',
    details: 'Butiran',
    empty: 'Tiada data',
    enrolled: 'Didaftarkan',
    free: 'Percuma',
    graph: 'Graf',
    loading: 'Sedang Dimuatkan...',
    lesson: 'pelajaran',
    lessons: 'pelajaran',
    live_assessment: 'Penilaian Secara Langsung',
    live_event: 'Acara Langsung',
    no: 'TIdak',
    of: 'Dari',
    or: 'Atau',
    organization: 'Organisasi',
    page: 'Halaman',
    pages: 'Halaman',
    personal: 'Peribadi',
    poll: 'Undian',
    rating: 'Penarafan',
    reset: 'Set Semula',
    signin: 'Log Masuk',
    signup: 'Daftar',
    soon: 'Sebentar lagi',
    type: 'Jenis',
    uploading: 'Memuat naik...',
    yes: 'Ya',
    something_went_wrong: 'Ada kesalahan!',
    view_all: 'Lihat Semua',
    upload_successful: 'Berjaya Muat Naik',
    upload_successful_message:
      'Dokumen excel anda berjaya dimuat dan sedang diproses. Ini memerlukan sedikit masa untuk selesai.',
    check_email_upload_successful:
      'Sila <0>semak e-mel anda</0> untuk <1>laporan</1> senarai pengguna yang telah dimuat naik.',
    is_private: 'Privasi'
  },

  account: {
    title: 'Akaun',
    subtitle: 'Mengendali seting dan maklumat akaun anda.',
    saved: 'Perubahan Akaun berjaya'
  },

  assessments: {
    title: 'Pernilaian',
    subtitle: 'Cipta Penilaian',
    finished: 'Penilaian sudah selesai',
    countdown: 'Penilaian secara langsung akan disiarkan dalam ',
    create: 'Cipta Penilaian',
    list_title: 'Penilaian Anda',
    delete_warning: 'Adakah anda pasti mahu memadamkan Item ini?',
    details_title: 'Tambah Butiran Penilaian',
    details_subtitle:
      'Namakan Penilaian anda dan beritahu penonton anda apa yang mereka dijangka akan belajar.',
    disclaimer: `Saya menjamin bahawa penilaian saya yang dicatat tidak akan:
    - melanggar hak mana-mana pihak ketiga
    - mengandungi sebarang unsur yang haram, termasuk fitnah, cabul, tidak senonoh, pornografi, keganasan, kekasaran, hina, ancam, atau diskriminasi kandungan, ataupun menyamar dengan asterisk
    - mengandungi sebarang unsur serangan peribadi terhadap orang lain
    - mengandungi penyamaran peserta lain, tokoh awam ataupun selebriti
    - mengandungi sebarang perkara atau maklumat peribadi mana-mana individu tanpa persetujuan individu tersebut dan tidak melanggar peraturan perlindungan data di mana-mana tempat di dunia ini
    - mengandungi sebarang kutipan komersial atau sebarang bentuk "spam”`
  },

  buildersettings: {
    title: 'Terbitkan Seting',
    subtitle:
      'Tambahkan seting ke acara anda, tentukan siapa yang boleh menonton dan berinteraksi dengan acara anda'
  },

  buttons: {
    market_place: 'Market Place',
    back_to_normal: 'Back To Normal',
    add: 'Tambah',
    add_page: 'Tambah halaman',
    add_lesson: 'Tambah ajaran',
    add_answer: 'Tambahkan jawapan baru',
    add_group: 'Tambah Kumpulan',
    add_organization: 'Tambah Organisasi',
    add_question: 'Tambah soalan',
    add_quiz: 'Tambah Kuiz',
    add_users: 'Tambah Pengguna',
    back: 'Kembali',
    back_to_course: 'Kembali ke Rumusan Kursus',
    back_to_lesson: 'Kembali ke Rumusan Pelajaran',
    back_to_media: 'Kembali ke Simpanan Media',
    back_to_details: 'Kembali ke butiran',
    cancel: 'Batal',
    clear: 'Kosongkan',
    close: 'Tutup',
    clone: 'Klon',
    close_lesson: 'Tutup Ajaran',
    clone_course: 'Klon Kursus',
    confirm: 'Sahkan',
    create: 'Cipta',
    download: 'Muat turun',
    download_mass_user_tamplate: 'Muat turun Templat',
    add_mass_users: 'Tambah Banyak Pengguna',
    upload_excel_list: 'Muat naik Senarai Excel',
    delete: 'Padamkan Media',
    edit: 'Edit',
    edit_course: 'Edit Kursus',
    enroll: 'Daftar',
    finish: 'Tamat',
    upload_image: 'Muat naik gambar',
    upload_image_video: 'Muat naik gambar atau video',
    select_media_library: 'Pilih simpanan media',
    make_public: 'Jadi Terbuka',
    make_private: 'Jadi Peribadi',
    make_org: 'Jadi Organisasi',
    media: 'Simpanan Media',
    my_theme: 'Tema Saya',
    next: 'Seterus',
    next_lesson: 'Ajaran Seterusnya',
    next_step: 'Langkah Seterusnya',
    previous_step: 'Langkah sebelumnya',
    publish: 'Terbit',
    publish_assessment: 'Terbitkan penilaian anda',
    publish_course: 'Terbitkan kursus anda',
    publish_event: 'Terbitkan acara anda',
    reset: 'Set Semula',
    reset_elements: 'Set Semula Elemen',
    save: 'Simpan',
    creating: 'Sedang Cipta...',
    updating: 'Sedang Kemas kini...',
    saved: 'Sudah Simpan',
    save_for_later: 'Simpan untuk nanti',
    save_settings: 'Simpan Seting',
    select_files: 'Pilih Fail',
    select_theme: 'Pilih Tema',
    start_lesson: 'Mulakan Pelajaran',
    update: 'Kemas kini',
    upload: 'Memuat Naik',
    upload_audio: 'Muat naik Audio',
    upload_photo: 'Muat naik gambar profil',
    upload_video: 'Muat Naik Video',
    enrolled: 'Sudah Daftar',
    unenroll: 'Daftar di bantal',
    from_library: 'Simpanan Media',
    remove: 'Padam',
    removed: 'Sudah Dipadam',
    start_broadcast: 'Mulakan Siaran',
    end_broadcast: 'Tamatkan Siaran',
    camera: 'Kamera',
    screen: 'Skrin',
    screen_with_camera: 'Skrin dengan Kamera'
  },

  card: {
    quick_add: 'Tambah Ringkas',
    add: 'Tambah',
    clone: 'Klon',
    completed: 'Pelajaran Selesai'
  },

  course: {
    upcoming_course: 'Kursus Akan Datang',
    unPublishEvent: 'Nyahterbitkan Acara',
    unPublishAssessment: 'Nyahterbitkan Penilaian',
    pastCourse: 'Latihan Kursus',
    upcoming: 'Acara Langsung Akan Datang',
    pastEvent: 'Acara Yang Lalu',
    pastAssessment: 'Penilaian yang lalu',
    upcomingAssessment: 'Penilaian Akan Datang',
    created: 'Tarikh Ditetap:',
    assignees: 'Wakil',
    organisations:
      ' {{ organisasi }} Organisasi, <2> {{ pengguna }} pengguna</2>',
    event_date: 'Tarikh acara langsung <1> {{ tarikh }} </1>',
    delete_warning: 'Adakah anda pasti mahu padam',
    clonning_no_lesson:
      'Sila tambah sekurang-kurangnya satu ajaran untuk klon kursus ini.',
    clone_warning: 'Adakah anda pasti mahu klon ini',
    clone_success: 'Klon sedang diproses',
    disclaimer: `Saya menjamin bahawa penilaian saya yang dicatat tidak akan:
    - melanggar hak mana-mana pihak ketiga
    - mengandungi sebarang unsur yang haram, termasuk fitnah, cabul, tidak senonoh, pornografi, keganasan, kekasaran, hina, ancam, atau diskriminasi kandungan, ataupun menyamar dengan asterisk
    - mengandungi sebarang unsur serangan peribadi terhadap orang lain
    - mengandungi penyamaran peserta lain, tokoh awam ataupun selebriti
    - mengandungi sebarang pekara atau maklumat peribadi mana-mana individu tanpa persetujuan individu tersebut dan tidak melanggar peraturan perlindungan data di mana-mana tempat di dunia ini
    - mengandungi sebarang kutipan komersial atau sebarang bentuk "spam”`
  },

  coursecreate: {
    dropzone_text: 'Masukkan Medica',
    sidebar_text: 'Pilih Satu Tema <1/> untuk <3/> Pelajaran Anda',
    delete_warning: 'Adakah anda pasti mahu memadamkan pelajaran ini?'
  },

  coursepage: {
    quizview_loading: 'Sedang semak jawapan. Sila tunggu...',
    quizview_answer: 'Jawapan Anda'
  },

  coursequiz: {
    title: 'Kuiz dalam semua Pelajaran'
  },

  dashboard: {
    tooltip_title: 'Jangan papar video ini lagi',
    page_title: 'Statistik Kursus Anda',
    page_subtitle: 'Status kursus anda',
    profile_add_info:
      'Tambah <1>{{Tekstidaklengkap}}</1> untuk melengkapkan profil anda.',
    profile_build:
      'Bina profil anda <1>sini</1>, beritahu kami minat dan kemahiran anda.',
    profile_title: 'Pelindungan Profil',
    more_details: 'Maklumat lanjut'
  },

  errors: {
    answer: 'Sila masukkan jawapan',
    answer_correct: 'Pilih jawapan yang betul',
    code: 'Sila masukkan kod anda',
    criterion: 'Sila masukkan kriteria',
    duration: 'Tempoh masa perlu diisi',
    element: 'Sila masukkan element',
    email: 'Sila masukkan e-mel anda',
    email_invalid: 'E-mel tidak sah',
    feedback_correct: 'Sila beri maklum balas, betul ',
    feedback_incorrect: 'Sila beri maklum balas, salah',
    host: 'Sila masukkan hos acara',
    host_assessment: 'Sila masukkan hos penilaian',
    image: 'Sila muat naik gambar',
    location: 'Sila masuk lokasi anda',
    live_location: 'Sila pilih lokasi siaran',
    limit: 'Sila masuk tempoh masa dalam minit untuk strim langsung anda',
    min_3char: 'Minimum 3 aksara',
    number: 'sila masuk nombor positif.',
    host_email_require: `E-mel hos diperlukan.`,
    attendee_email_require: `E-mel peserta diperlukan.`,
    name: 'Sila masukkan nama anda',
    not_found_course: 'Kursus tidak dijumpai',
    not_found_event: 'Acara tidak dijumpai',
    not_found_assessment: 'Penilaian tidak dijumpai',
    password: 'Sila masukkan kata laluan anda',
    password_digit: 'Minimum satu nombor digit diperlukan',
    password_short: 'Kata laluan terlalu pendek, perlukan minimum 10 aksara',
    password_special: 'Minimum satu aksara khas',
    password_uppercase: 'Minimum satu huruf besar',
    password_lowercase: 'Minimum satu huruf kecil',
    phone: 'Sila masukkan telefon anda',
    phone_invalid: 'Nombor telefon tidak sah',
    position: 'Sila masukkan posisi anda',
    question: 'Sila masukkan soalan',
    start_date: 'Tarikh & Waktu Permulaan diperlukan',
    tag: 'Sila pilih satu teg',
    topics: 'Sila pilih minimum satu topik.',
    live_topics: 'Sila tambah topik',
    title: 'Sila masukkan tajuk',
    title_assessment: 'Sila masukkan tajuk penilaian',
    title_course: 'Sila masukkan tajuk kursus',
    title_empty: 'Tajuk tidak boleh kosong',
    title_event: 'Sila masukkan tajuk acara',
    title_lesson: 'Sila masukkan tajuk pelajaran',
    title_quiz: 'Sila masukkan nama kuiz',
    username: 'Sila masukkan nama pengguna anda',
    upload_error: 'Ralat - Fail tidak sesuai!',
    upload_more_than_10: 'Anda hanya boleh memuat naik maksimum 10 fail setiap kali.',
    topics_max: 'Sila tambah maksimum 3 topik.',
    upload_excel: 'Sila pastikan anda telah memuat naik fail yang betul.',
    title_excel: 'Ralat ketika memuat naik templat:',
    file_size_exceed: 'Saiz fail terlalu besar',
    subtitle_excel:
'Pastikan anda menggunakan templat yang disediakan dan isi dalam ruang dengan maklumat yang betul.',
    select_broadcast_option: 'Sila tentukan pilihan untuk siaran acara',
    multi_hosts_number_error:
'Bilangan penyampai tidak boleh melebihi bilangan yang ditentukan untuk acara.',
    conference_people_number_error: `Bilangan penonton tidak boleh melebihi bilangan yang ditentukan untuk acara.`,
    select_max_host: 'Pilih minimum 1 penyampai untuk acara.',
    select_max_conference: 'Pilih minimum 1 penonton untuk acara.',
    stream_stop_error: 'Ralat, Strim Ditamatkan!',
    unsecure_context:
'Ralat Fatal: Pelayar tidak dapat mengakses kamera dan mikrofon kerana konteks yang tidak selamat. Sila pasangkan SSL and akses melalui https',
    ws_not_supported: 'Ralat Fatal:WebSocket tidak disokong oleh pelayar ini'
  },

  events: {
    title: 'Tambahkan Butiran Acara Langsung',
    change_host: 'Tukar Hos',
    finished: 'Acara dah tamat',
    countdown: 'Acara langsung akan disiarkan dalam ',
    subtitle:
  'Namakan acara anda dan beritahu penonton anda apa yang mereka dijangka akan belajar.',
    poll_disabled: 'Undian tidak tersedia dalam acara ini',
    disclaimer: `Saya menjamin bahawa penilaian saya yang dicatat tidak akan:
    - melanggar hak mana-mana pihak ketiga
    - mengandungi sebarang unsur yang haram, termasuk fitnah, cabul, tidak senonoh,  pornografi, keganasan, kekasaran, hina, ancam, atau diskriminasi kandungan, ataupun menyamar dengan asterisk
    - mengandungi sebarang unsur serangan peribadi terhadap orang lain
    - mengandungi penyamaran peserta lain, tokoh awam ataupun selebriti
    - mengandungi sebarang perkara atau maklumat peribadi mana-mana individu tanpa persetujuan individu tersebut dan tidak melanggar peraturan perlindungan data di mana-mana tempat di dunia ini
    - mengandungi sebarang kutipan komersial atau sebarang bentuk "spam”'`,
    prompt_message:
  'Keluar dari halaman ini akan tamatkan acara anda. Adakah anda pasti nak keluar dari halaman ini?',
    duration_exceed_message:
  'Masa siaran anda melebihi had yang ditetapkan, aplikasi akan hentikan penyiaran.',
    before_schedule_message:
  'Anda akan memulakan siaran sebelum waktu acara yang dijadualkan. Harap maklum bahawa jika anda menghentikan siaran, acara akan ditamatkan.',
    browser_unsupportive_message:
  'Pelayar anda tidak menyokong Screen Share. Anda akan dapat cari pelayar yang disokong melalui pautan ini ',
    cancel_switch_host_message:
  'Hos tidak tersedia. Acara ini akan disambung dari sambungan anda.',
    coaching_prompt_message:
  'Anda tidak boleh keluar dari halaman ini sehingga acara ditamatkan.',
    event_modal_warn: 'Anda mahu tamatkan acara ini?',
    confirm_message: 'Acara anda akan tamat jika anda klik OK.',
    screen_share_denied: 'Anda menolak untuk mempamerkan skrin anda',
    media_not_found:
  'Kamera atau Mikrofon tidak dapat dijumpai atau tidak dibenarkan di peranti anda.',
    media_not_access:
  'Kamera atau Mic digunakan oleh proses yang lain yang tidak memberi akses kepada peranti',
    constraint_error:
  'Tidak ada peranti yang sesuai dengan kekangan video dan audio anda. Anda boleh mengubah kekangan video dan audio',
    media_access_denied: 'Anda tidak dibenar untuk akses kamera dan mikrofon.'
  },

  filters: {
    days7: '7 hari yang lalu',
    days15: '15 hari yang lalu',
    days30: '30 hari yang lalu',
    days365: '365 hari yang lalu',
    date: 'Tarikh dicipta',
    relevance: 'Relevansi',
    popularity: 'Populariti',
    name: 'Nama',
    group: 'Kumpulan',
    Newest_to_Oldest: 'Terbaru Hingga Terlama',
    Oldest_to_Newest: 'Terlama Hingga Terbaru',
    A_Z: 'A ke Z',
    Z_A: 'Z ke A'
  },

  helpers: {
    password:
    'Untuk melindungi keselamatan akaun anda, kami memerlukan minimum satu huruf kecil, nombor dalam kata laluan anda. Panjang kata laluan juga perlu mempunyai minimum 10 aksara. ',
    phone: 'Sila masukkan kod telefon negara anda, contoh: +65',
    username:
  'Nama pengguna anda diguna sebagai maklumat awam dan akan dikongsikan dengan pengguna lain mengikut keperluan. Oleh itu, kami cadangkan agar anda tidak bubuh maklumat peribadi dalam nama pengguna anda',
    public_description_normal:
  '<0><0/></0> anda telah disimpan dan dikelaskan peribadi secara lalai. Ini bermakna hanya anda yang boleh akses kandungan ini. Untuk menerbitkan kandungan ini, anda boleh memilih salah satu pilihan di bawah. Menerbitkan kursus anda menjadi Terbuka bermaksud bahawa ia akan tersedia dan dilihat oleh semua pengguna di platform. Pilihan Untuk Pengguna Khusus sahaja akan membolehkan anda berkongsi kursus anda dengan pengguna tertentu menggunakan alamat e-mel yang paut dengan akaun Sharelook mereka.',
    public_description_admin:
  '<0><0/></0> telah disimpan dan dikelaskan peribadi secara lalai. Ini bermaksud bahawa hanya anda (dan pencipta kandungan) dapat melihat kandungan ini. Untuk menerbitkan kandungan ini, anda boleh memilih salah satu pilihan di bawah. Menerbitkan kursus anda menjadi Terbuka bermaksud bahawa ia akan tersedia untuk semua pengguna di platform - termasuk mereka yang berada di luar organisasi anda. Menerbit ke organisasi bermaksud semua pengguna dalam organisasi akan dapat melihatnya. Anda juga boleh menerbitkannya kepada lebih dari 1 kumpulan, yang bermaksud hanya pengguna dalam kumpulan tersebut yang dapat melihatnya. Akhirnya, anda mempunyai pilihan untuk menerbit kepada pengguna tertentu di dalam dan di luar organisasi anda menggunakan alamat e-mel akaun Sharelook mereka.'
  },

  labels: {
    add: 'Tambah',
    portrait: 'Crop Portrait',
    landscape: 'Crop Landscape',
    answer_type: 'Jenis Jawapan',
    answers: 'Jawapan',
    back_to_quiz: 'Balik ke senarai Kuiz',
    back_to_question: 'Balik ke senarai soalan',
    chat: 'Sembang',
    chat_available: 'kotak Sembang tidak tersedia dalam acara ini',
    chat_report: 'Laporan Sembang',
    choice_single: 'Pilihan tunggal',
    choice_multiple: 'Pelbagai pilihan',
    choice_free: 'Pilihan"Bebas',
    choice_sorting: 'Pilihan"Pengisihan',
    choice_matrix: 'Pilihan"Pengisihan Matrix',
    clone_lesson_permission: 'Kebenaran Klon',
    code: 'Kod',
    correct: 'Betul',
    created: 'Tarikh Dicipta',
    clone_modal: 'Klon Kursus',
    cloning_course: 'Kursus Sedang Diklon...',
    cloning: 'Sedang Klon...',
    cloning_course_desc: 'Proses ini akan memakan sikit masa. Sila bersabar',
    cloning_success: 'Kursus "<0/>" telah berjaya diklon!',
    description: 'Penerangan',
    disclaimer: 'Notis Penafian',
    drop_file: 'Letak fail di sini...',
    duration: 'Tempoh',
    edit: 'Edit',
    email: 'E-mel',
    event: 'Acara',
    event_all: 'Semua Acara',
    event_date: 'Tarikh / Waktu Tempatan Acara Langsung',
    event_this: 'Acara ini',
    expire: 'Tamat pada',
    expiry_date: 'Tarikh Luput',
    forgot: 'Terlupa Kata Laluan?',
    group: 'Kumpulan',
    groups_list: 'Senarai Kumpulan',
    host: 'Hos',
    id_annotation: 'Identiti anotasi',
    id_quiz: 'Identiti Kuiz',
    incorrect: 'Salah',
    interests: 'Minat',
    invited: 'Dijemput',
    live_chat: 'Perbincangan Secara Langsung',
    live_stream_limit: 'Tempoh Minit Strim',
    contact_text: 'Untuk menukar had tempoh strim bulanan anda, sila hubungi',
    contact_admin:
  '<0>Jika anda ingin tukar had tempoh strim bulanan anda, sila hubungi</0> <1>admin@sharelook.com</1>',
    limit_stream_text:
  'Baki Tempoh Strim Dalam Minit: <0>{{ had }}</0> minit <1/><2/> <3>Untuk menukar had tempoh strim bulanan anda, sila hubungi</3> <4>admin@sharelook.com</4>',
    location: 'Lokasi',
    lessons: 'Ajaran',
    location_broadcast: 'Lokasi Peservis Hos',
    location_broadcast_subtitle:
  'Masukkan lokasi yang paling dekat dengan lokasi Hos siaran untuk mengurangkan kelewatan audiol',
    media_manager: 'Pengurus Media',
    minutes: 'Minit',
    name: 'Nama',
    online_quiz: 'Kuiz Dalam Talian',
    organiser: 'Pencipta',
    organization: 'Organisasi',
    overall_emotion: 'Pengalaman keseluruhan:',
    organizations_list: 'Senarai Organisasi',
    password: 'Kata Laluan',
    participants: 'Peserta',
    picture: 'Gambaran (16:9)',
    phone: 'Telefon',
    photo: 'Telefon',
    poll: 'Undian',
    position: 'Posisi',
    processing: 'Sedang diproses',
    privacy_settings: 'Seting Privasi',
    question: 'Soalan',
    quiz_create: 'Cipta Kuiz Baru',
    quiz_name: 'Nama Kuiz',
    quiz_update: 'Kemas kini Kuiz',
    select_organization: 'Pilih satu organisasi',
    settings: 'Seting',
    show: 'Papar',
    show_graph: 'Paparkan keputusan graf',
    signin: 'Log Masuk',
    signup: 'Daftar',
    sort_by: 'Susun ikut',
    start_date: 'Tarikh Permulaan',
    tags: 'Teg',
    terms: 'Saya bersetuju dengan <1>terma dan syarat ini</1>.',
    title: 'Tajuk',
    topics: 'Topik',
    topic: 'Topik',
    total_comments: 'Jumlah Komen',
    username: 'Nama Pengguna',
    users_list: 'Senarai Pengguna',
    users_emails: 'Masukkan e-mel pengguna yang ditetapkan',
    description_specifiction_email:
  'Sila hanya masukkan 1 alamat e-mel untuk setiap baris untuk berkongsi dengan beberapa pengguna yang ditetapkan.',
    message_specific_email: 'Sila masukkan e-mel pengguna yang ditetapkan.',
    viewers: 'Penonton',
    edit_course: 'Edit',
    edit_assessment: 'Edit',
    edit_event: 'Edit',
    delete_course: 'Padam',
    delete_event: 'Padam',
    delete_assessment: 'Padam',
    view_course: 'Tonton',
    view_event: 'Tonton',
    view_assessment: 'Tonton',
    date_event: 'Tarikh Acara Langsung',
    date_assessment: 'Tarikh Penilaian',
    clone_of: 'Klon',
    clone_course:
  'Klon kursus ini yang membenarkan anda untuk membuat perubahan secara bebas, termasuk semua pelajaran dan halaman.',
    make: 'Buat',
    available_to: 'tersedia untuk mana-mana pengguna ShareLook',
    uploaded_by: 'Dimuat naik oleh: ',
    course: 'Kursus',
    assessment: 'Penilaian',
    user_not_exist: 'Pengguna tidak wujud, anda masih ingin menghantar jemputan?',
    check_user: 'Notis',
    user_not_exist_in_org:
  'Pengguna ini tidak wujud dalam organisasi ini, anda masih ingin menghantar jemputan?',
    title_modal_stream: 'Tukar Had Strim Organisasi',
    des_warning_stream: 'Anda akan Tukar',
    monthly_stream: 'had strim bulanan:',
    min_per_month: 'minit/bulan',
    broadcast_label: 'Saya nak:',
    hosts_emails: `Masukkan e-mel hos`,
    attendee_emails: `Masukkan e-mel peserta`,
    description_host_specifiction_email:
  'Sila hanya isi 1 alamat e-mel untuk setiap baris.',
    presenter_label: 'Penyampai',
    presenter_label_conference: 'Bilangan Orang',
    event_privacy: 'Mod Persidangan'
  },

  broadcastOptions: {
    stream_from_phone: 'Siaran Langsung dari telefon saya',
    other_webrtc: 'Persidangan web dari komputer saya',
    multihost: 'Persidangan web Multicast dari komputer saya',
    peer2peer: 'Sesi Bimbingan',
    conference: 'Konferensi Secara Langsung'
  },

  lessoncreate: {
    title: 'Tambah butiran pelajaran',
    subtitle:
  'Namakan ajaran anda dan beritahu penonton anda apa yang mereka dijangka akan belajar.',
    input_label_title: 'Tajuk Pelajaran',
    input_label_topics: 'Topik Pelajaran',
    input_label_description: 'Penerangan Pelajaran',
    delete_warning: 'Adakah anda pasti mahu memadam halaman ini?'
  },

  lessonoverview: {
    title: 'Tambah Pelajaran',
    subtitle: 'Tambah pelajaran yang sedia ada atau cipta yang baru',
    new_lesson: 'Cipta pelajaran baru',
    new_lesson_sub: 'Cipta pelajaran baru dari awal!',
    existing_lesson: 'Pilih pelajaran yang sedia ada',
    existing_lesson_sub:
  'Sambung ke pelajaran yang sedia ada, perubahan yang dibuat kepada pelajaran ini juga akan mempengaruhi pelajaran ini di kursus lain.',
    clone_lesson: 'Membuat salinan pada pelajaran sedia ada',
    clone_lesson_sub:
  'Buat salinan unik untuk pelajaran dalam kursus ini, perubahan yang dibuat pada pelajaran ini tidak akan tukar pelajaran asalnya.',
    clone_lesson_modal_sub:
  'Sila klik butang klon di bawah pelajaran yang anda ingin masukkan ke kursus anda.'
  },

  management: {
    groups_title: 'Mengendali Kumpulan',
    delete_warning: 'Adakah anda pasti?',
    organizations_title: 'Organisasi Saya',
    organizations_subtitle: 'Tambah organisasi ke senarai anda',
    users_title: 'Mengendali Pengguna',
    users_position: 'Pengurus Kanan Akaun',
    user_not_found: 'Pengguna tidak dapat dijumpai',
    select_org: 'Sila cari dan pilih satu organisasi untuk menguruskan akaun pengguna'
  },

  audio: {
    modal_title: 'Masukkan Audio',
    list_view: 'Paparan Senarai',
    create_audio_modal_title: 'Cipta Audio',
    edit_audio_modal_title: 'Edit Audio',
    public_audio_not_found: 'Audio tidak dapat dijumpai.',
    private_audio_not_found: 'Anda masih belum memuat naik audio',
    are_you_sure_to_delete: 'Adakah anda pasti untuk memadam?',
    type_something: 'Tulis sesuatu',
    select_voice: 'Pilih',
    file_name: 'Nama Fail',
    description: 'Penerangan',
    topic: 'Topik',
    key_words_tag: 'Kata kunci Teg',
    mp3_audio: 'Audio MP3',
    created: 'Sudah Dicipta',
    duration: 'Tempoh',
    close: 'tutup'
  },

  image: {
    modal_title: 'Masukkan Imej',
    image: 'Imej',
    pixel: 'Pixel',
    dimension: 'Dimension',
    public_image_not_found: 'Image not found.',
    private_image_not_found: 'Anda masih belum memuat naik gambar'
  },

  annotation: {
    modal_title: 'Anotasi'
  },

  text: {
    modal_title: 'Penyunting Teks'
  },

  video: {
    modal_title: 'Masukkan Video',
    image: 'Video',
    mp4_video: 'MP4 Video',
    public_video_not_found: 'Video tidak dapat dicari.',
    private_video_not_found: 'Anda masih belum memuat naik video'
  },

  media: {
    title: 'Simpanan Media',
    subtitle: 'Simpanan Fail Anda',
    modal_title: 'Memuat naik media',
    delete_warning: 'Sah memadam',
    delete_message:
  'Media yang dipadam masih akan wujud di halaman yang mereka digunakan ',
    dropzone_text: 'atau Seret dan Lepas',
    delete_success: 'Media telah berjaya dipadam',
    upload_file: 'Memuat naik fail',
    drag_drop: 'atau Seret dan Lepas',
    import_file: 'Import fail dari komputer anda',
    no_media: 'Anda masih belum memuat naik media',
    media_type: 'Jenis Media',
    video: 'Video',
    image: 'Imej',
    audio: 'Audio',
    transcribed_text: 'Transcribed Text',
    gif: 'GIF',
    media_not_found: 'Media tidak dapat dicari.',
    of: 'of',
    disclaimer: `Saya menjamin bahawa penilaian saya yang dicatat tidak akan:
    - melanggar hak mana-mana pihak ketiga
    - mengandungi sebarang unsur yang haram, termasuk fitnah, cabul, tidak senonoh,  pornografi, keganasan, kekasaran, hina, ancam, atau diskriminasi kandungan, ataupun menyamar dengan asterisk
    - mengandungi sebarang unsur serangan peribadi terhadap orang lain
    - mengandungi penyamaran peserta lain, tokoh awam ataupun selebriti
    - mengandungi sebarang perkara atau maklumat peribadi mana-mana individu tanpa persetujuan individu tersebut dan tidak melanggar peraturan perlindungan data di mana-mana tempat di dunia ini
    - mengandungi sebarang kutipan komersial atau sebarang bentuk "spam”'`
  },

  navigation: {
    account: 'Akaun',
    assessments: 'Penilaian',
    dashboard: 'Papan Pemuka',
    groups: 'Pengendalian Kumpulan',
    logout: 'Log Keluar',
    organisations: 'Organisasi',
    organizations_users: 'Organisasi dan Pengguna',
    reports: 'Laporan',
    schedule: 'Jadual',
    training: 'Latihan',
    nowLive: 'Bersiaran',
    users: 'Pengguna',
    workshop: 'Bengkel Saya'
  },

  onboarding: {
    step1_title: 'Langkah 1: Beritahu Kami Serba Sedikit Tentang Anda',
    step1_subtitle:
  'Apakah nama awak? Anda datang dari mana? Apakah tajuk pekerjaan anda?',
    step2_title: 'Langkah ke-2: Pilih Beberapa Kemahiran yang Anda Ingin Mahirkan',
    step2_subtitle:
  'Seterusnya, beritahu kami apa yang anda ingin belajar dengan lebih lanjut. Ia mungkin sesuatu yang anda belum belajar lagi? Bidang yang baru?Ataupun sesuatu yang orang kesayangan anda buat? '
  },

  pagebuilder: {
    title: 'Cipta Ajaran',
    subtitle:
  'Masa untuk mencipta kandungan untuk penonton anda supaya mereka dapat belajar dari anda, anda boleh masukkan gambar, video dan infografik ',
    select_layout: 'Pilih Tataletak Halaman',
    template1: 'Kosong',
    template2: 'Tajuk & Sarikata',
    template3: 'Tajuk & Teks',
    template4: 'Tajuk, Media & Teks',
    template5: 'Tajuk & Media',
    template6: 'Tajuk & Kuiz'
  },

  pageconstructor: {
    title: 'Cipta dan Klon Pelajaran',
    subtitle:
  'Masa untuk mencipta kandungan untuk penonton anda supaya mereka dapat belajar dari anda, anda boleh masukkan gambar, video dan infografik '
  },

  passwordreset: {
    success_coded:
    'Kami telah hantar kod pengesahan ke alamat e-mel yang anda berikan, sila salin kod tersebut ke ruang di bawah untuk set semula kata laluan yang baru.',
    success_changed:
  'Anda telah berjaya menetapkan kata laluan yang baru. Anda boleh log masuk sekarang. ' },

  placeholders: {
    search: 'Cari',
    answer: 'Jawapan',
    chat: 'Tulis Sesuatu...',
    code: 'Kod',
    criterion: 'Kriteria',
    date_event: 'Pilih tarikh & masa',
    date_start: 'Tarikh Permulaan',
    date_expire: 'Tarikh Tamat Tempoh',
    description: 'Penerangan',
    elements: 'Susun elemen',
    email: 'E-mel',
    feedback_correct: 'Maklum Balas Betul',
    feedback_incorrect: 'Maklum Balas Salah',
    host: 'Hos',
    keywords: 'Cari kata kunci(lebih dari 1)',
    lesson_description: 'Penerangan Pelajaran',
    location: 'Lokasi',
    minutes: 'Minit',
    name: 'Nama',
    organiser: 'Pencipta',
    organization: 'Organisasi',
    password: 'Kata Laluan',
    phone: 'Telefon',
    photo: 'Gambar',
    picture: 'Gambar',
    point: 'Titik',
    position: 'Posisi',
    question: 'Soalan',
    quiz: 'Nama Kuiz',
    search_course: 'Cari Mengikut Kursus',
    search_media: 'Cari media',
    search_name: 'Cari mengikut Nama',
    search_title: 'Cari mengikut Tajuk',
    search_training: 'Cari Latihan',
    settings: 'Seting',
    tags: 'Teg',
    title: 'Tajuk',
    topics: 'Topik',
    username: 'Name Pengguna',
    keyword: 'Kata Kunci',
    max_500_characters: 'Maksimum 500 Aksara ',
    no_description: 'Fail ini tidak mempunyai penerangan',
    no_keyword: 'Fail ini tidak mempunyai kata kunci',
    no_topics: 'Fail ini tidak mempunyai set topik',
    feedback: 'Mesej',
    contact: 'Bagaimana kita boleh membantu?'
  },

  publishsettings: {
    title: 'Terbit Seting',
    event_subtitle:
  'Tetapkan seting di acara anda, siapa yang dapat menonton dan berinteraksi dengan acara anda',
    assessment_subtitile:
  'Namakan Penilaian anda dan beritahu penonton anda apa yang mereka jangka akan belajar ',
    course_subtitle:
  'Tetapkan seting di acara anda, siapa yang dapat menonton dan berinteraksi dengan acara anda',
    disclaimer:
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam venenatis tellus ex, eu auctor diam tristique et. Fusce vel egestas felis, vel malesuada justo. Suspendisse erat orci, dapibus a nisi quis, ultricies mattis arcu. Proin in suscipit metus. Sed mi tellus, porta in porta eu, accumsan a purus. Donec quis turpis vestibulum, consequat urna ut, vestibulum ex. Sed vulputate ornare auctor. Proin gravida luctus justo at interdum. Proin porttitor, turpis et tincidunt lobortis, dui tortor viverra risus, quis venenatis Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam venenatis tellus ex, eu auctor diam tristique et. Fusce vel egestas felis, vel malesuada justo. Suspendisse erat orci, dapibus a nisi quis, ultricies mattis arcu. Proin in suscipit metus. Sed mi tellus, porta in porta eu, accumsan a purus. Donec quis turpis vestibulum, consequat urna ut, vestibulum ex. Sed vulputate ornare auctor. Proin gravida luctus justo at interdum. Proin porttitor, turpis et tincidunt lobortis, dui tortor viverra risus, quis venenatis Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam venenatis tellus ex, eu auctor diam tristique et. Fusce vel egestas felis, vel malesuada justo. Suspendisse erat orci, dapibus a nisi quis, ultricies mattis arcu. Proin in suscipit metus. Sed mi tellus, porta in porta eu, accumsan a purus. Donec quis turpis vestibulum, consequat urna ut, vestibulum ex. Sed vulputate ornare auctor. Proin gravida luctus justo at interdum. Proin porttitor, turpis et tincidunt lobortis, dui tortor viverra risus, quis venenatis Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam venenatis tellus ex, eu auctor diam tristique et. Fusce vel egestas felis, vel malesuada justo. Suspendisse erat orci, dapibus a nisi quis, ultricies mattis arcu. Proin in suscipit metus. Sed mi tellus, porta in porta eu, accumsan a purus. Donec quis turpis vestibulum, consequat urna ut, vestibulum ex. Sed vulputate ornare auctor. Proin gravida luctus justo at interdum. Proin porttitor, turpis et tincidunt lobortis, dui tortor viverra risus, quis venenatis Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam venenatis tellus ex, eu auctor diam tristique et. Fusce vel egestas felis, vel malesuada justo. Suspendisse erat orci, dapibus a nisi quis, ultricies mattis arcu. Proin in suscipit metus. Sed mi tellus, porta in porta eu, accumsan a purus. Donec quis turpis vestibulum, consequat urna ut, vestibulum ex. Sed vulputate ornare auctor. Proin gravida luctus justo at interdum. Proin porttitor, turpis et tincidunt lobortis, dui tortor viverra risus, quis venenatis Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam venenatis tellus ex, eu auctor diam tristique et. Fusce vel egestas felis, vel malesuada justo. Suspendisse erat orci, dapibus a nisi quis, ultricies mattis arcu. Proin in suscipit metus. Sed mi tellus, porta in porta eu, accumsan a purus. Donec quis turpis vestibulum, consequat urna ut, vestibulum ex. Sed vulputate ornare auctor. Proin gravida luctus justo at interdum. Proin porttitor, turpis et tincidunt lobortis, dui tortor viverra risus, quis venenatis',
    dates_validation_error: 'Kedua-dua tarikh mesti diisi.',
    emails_validation_error: 'Senarai e-mel tidak sah.',
    specific_email_validation_error: 'Hanya terima satu e-mel sahaja.',
    i_agree_to_these: 'Saya bersetuju dengan:',
    terms_and_conditions: 'terma dan syarat.',
    PublicDescription:
  'Pengguna bebas: (pilihan peribadi dan terbuka) [Kursus | Acara | Penilaian] anda telah disimpan dan dikelas peribadi secara lalai. Ini bermakna hanya anda yang dapat melihat kandungan ini. Untuk menerbitkan kandungan ini, anda boleh menukar menjadi status terbuka di bawah. Ini bermaksud bahawa kursus ini akan tersedia untuk semua pengguna di platform. ',
    OrganisationsDescription:
  'Pengguna Organisasi: (Jangan pilih "" Selesai "" pilih "" Terbit "" dan bawa anda ke halaman penerbitan yang sama dengan pengguna lain tanpa pilihan penerbitan.) [Kursus | Acara | Penilaian] anda telah disimpan dan dikelaskan Peribadi. Ini bermakna hanya anda dan Pengendali dalam organisasi anda dapat melihatnya. Sebagai pengguna, anda tidak dapat menerbit kandungan sendiri dalam organisasi anda kerana ini memerlukan kebenaran Pengendali. Sila hubung salah satu Pengendali anda dan minta mereka menerbitkan kandungan anda secara terbuka ke seluruh organisasi, ke kumpulan tertentu dalam organisasi anda atau kepada pengguna tertentu. ',
    OrganisationGroupsDescription:
  'Pengendali Organisasi: (Untuk kandungan yang dicipta dalam organisasi: Peribadi, awam, organisasi, kumpulan, pengguna tertentu): [Kursus | Acara | Penilaian] ini telah disimpan dan dikelaskan Peribadi secara lalai. Ini bermaksud bahawa hanya anda (dan pencipta kandungan) yang dapat melihat kandungan ini. Untuk menerbitkan kandungan ini, anda boleh pilih salah satu pilihan di bawah. Menerbitkan kursus anda ke status terbuka bermaksud bahawa ia akan tersedia untuk semua pengguna di platform - termasuk mereka yang berada di luar organisasi anda. Menerbitkannya ke organisasi bermaksud semua pengguna dalam organisasi akan dapat melihatnya. Anda juga boleh menerbit lebih dari 1 kumpulan, ini bermaksud hanya pengguna dalam kumpulan tersebut yang dapat melihatnya. Akhirnya, anda mempunyai pilihan untuk menerbitkannya kepada pengguna tertentu di dalam dan di luar organisasi anda menggunakan alamat e-mel yang paut dengan akaun Sharelook mereka. ',
    SpecificUsersDescription:
  'Pengguna berbayar: (pengguna peribadi, awam dan pengguna tertentu) [Kursus | Acara | Penilaian] anda telah disimpan dan dikelaskan Peribadi secara lalai. Ini bermakna hanya anda yang dapat melihat kandungan ini. Untuk menerbitkan kandungan ini, anda boleh pilih salah satu pilihan di bawah. Menerbitkan kursus anda ke status terbuka bermaksud ia akan tersedia untuk semua pengguna di platform. Pilihan Pengguna Tertentu akan membolehkan anda berkongsi kursus anda dengan pengguna tertentu menggunakan alamat e-mel yang paut dengan akaun Sharelook mereka. '
  },

  quiz: {
    quiz_empty: 'Anda masih belum cipta kuiz ',
    questions_empty: 'Anda masih belum cipta soalan '
  },

  regions: {
    asia_pacific_australia: 'Australia',
    asia_pacific_india: 'India',
    asia_pacific_japan: 'Japan',
    asia_pacific_s_korea: 'Korea Selatan',
    asia_pacific_singapore: 'Singapura',
    asia_pacific_taiwan: 'Taiwan',
    eu_belgium: 'Belgium',
    eu_germany: 'Jerman',
    eu_ireland: 'Ireland',
    south_america_brazil: 'Brazil',
    us_central_iowa: 'Iowa',
    us_east_s_carolina: 'Carolina Selatan',
    us_east_virginia: 'Virginia',
    us_west_california: 'California',
    us_west_oregon: 'Oregon'
  },

  reports: {
    title: 'Laporan'
  },

  signup: {
    success_step1:
    'Kami telah hantar kod pengesahan ke alamat e-mel yang anda berikan, sila salinkan kod tersebut ke ruang di bawah untuk mengesahkan pendaftaran anda.',
    success_step2: 'Terima kasih. Anda telah berjaya mendaftar. ',
    privacy: `Saya setuju dengan <1> terma & syarat </1> dan <3> polisi privasi </3>`
  },

  stream: {
    emotion_impressive: 'Mengagumkan',
    emotion_unimpressive: 'Biasa saja',
    message_not_started: 'Akan Datang',
    message_running: 'Siaran Langsung',
    message_processing:
  'Kami sedang proses rakaman siaran langsung. Sila kembali sebentar lagi untuk tonton video dan masukkan penilaian dan maklum balas anda'
  },

  tabs: {
    audience: 'Penonton',
    course: 'Rumusan Kursus',
    details: 'Butiran Acara',
    description: 'Penerangan',
    host: 'Hos',
    lesson: 'Rumusan Pelajaran',
    lessons: 'Ajaran',
    overview: 'Rumusan',
    page: 'Pembina Halaman',
    publish: 'Terbit',
    settings: 'Terbitkan Seting',
    total_views: 'Jumlah tontonan',
    live_participates: 'Peserta Secara Langsung',
    live_chats: 'Kotak Sembang Secara Langsung',
    live_quiz: 'Undian Secara Langsung',
    trainer_rating: 'Penilaian Jurulatih',
    trainer_times: 'Sesi Jurulatih',
    courses_quizzes: 'Kuiz Kursus',
    user_list: 'Senarai Pengguna',
    discussion: 'Perbincangan',
    notes: 'Nota Saya'
  },

  topics: {
    SALES_TRAINING: 'Latihan Jualan',
    NEGOTIATION_TRAINING: 'Latihan Rundingan',
    CROSS_CULTURAL_AWARENESS: 'Pengetahuan Merentas Budaya',
    NETWORKING_SKILLS: 'Kemahiran Membina Perhubungan',
    SOFTWARE_ARCHITECTURE: 'Senibina Perisian',
    PROJECT_MANAGEMENT: 'Pengurusan Projek',
    DIGITAL_TRANSFORMATION: 'Transformasi Digital',
    IT_CONSULTING: 'Konsultan IT',
    MANAGEMENT_CONSULTING: 'Konsultan Pengurusan',
    HR_CONSULTING: 'Konsultan Sumber Daya Manusia',
    INTERNET_OF_THINGS: 'Internet untuk Segalanya (IoT)',
    CYBERSECURITY: 'Sekuriti Siber',
    PRIVACY_AND_GDRP: 'Privasi dan Peraturan Umum Perlindungan Data(GDPR)'
  },

  training: {
    title: 'Latihan',
    title_assessment: 'Penilaian',
    subtitle: 'Kursus dan Acara Langsung',
    enrolled_title: 'Kursus dan Acara Yang Didaftar',
    enrolled_subtitle: 'Kursus dan Acara Yang Anda Sertai',
    enrolled_message:
  'Anda belum daftar sebarang kursus dan acara.',
    past_live_event_title: 'Acara Langsung yang lalu',
    past_live_event_subTitle: 'Acara Langsung yang tamat',
    past_live_event: 'Tidak Ada Acara Langsung yang Lalu.',
    recomended_title: 'Kursus dan Acara yang Dicadangkan',
    now_live_event_title: 'Kini Berlangsung',
    now_live_event_subTitle: 'Acara Langsung yang disiarkan sekarang atau sebentar lagi',
    now_live_event: 'Tidak ada siaran langsung buat masa ini.',
    webinar_event_title: 'Saluran Persidangan Web',
    webinar_event_subTitle: 'Persidangan Web yang telah Tamat',
    webinar_event: 'Tiada Persidangan Web Buat Masa Sekarang.',
    p2p_event_title: 'Sesi Bimbingan',
    p2p_event_subTitle: 'Sesi Bimbingan yang telah Tamat',
    p2p_event: 'Tiada Sesi Bimbingan Buat Masa Sekarang.',

    now_live_assessment_title: 'Kini Berlangsung',
    now_live_assessment_subTitle:
  'Penilaian Langsung yang disiarkan sekarang atau sebentar lagi',
    now_live_assessment_message: 'Tiada Penilaian Langsung Buat Masa Sekarang.',

    upcoming_assessment_title: 'Penilaian Langsung Yang Akan Datang',
    upcoming_assessment_subtitle: 'Penilaian Langsung Yang Akan Datang',
    upcoming_assessment_message:
  'Tiada Penilaian Langsung Akan Datang Buat Masa Sekarang.',

    past_live_assessment_title: 'Penilaian Langsung yang Lalu',
    past_live_assessment_subTitle: 'Penilaian Langsung yang telah Tamat',
    past_live_assessment_message:
  'Tiada Penilaian Langsung yang Lalu Buat Masa Sekarang.',

    /**
     * <0/> get index 0 of data from Trans component
     * exp -->
     * <Trans i18nKey='training:recomended_subtitle' >
     *    <Navlink>{...something}</Navlink> --> is index 0 of Trans component
     *    <h1>{...something}</h1> --> is index 1 of Trans component
     * </Trans>
     */
    recomended_subtitle:
  'Kami telah menyusun kursus dan acara langsung berdasarkan <0><0/></0> anda',
    /**
   * and we also can get data from index to replace in recommended_subtitle by like above string.
   * for exp -->
   * at the end of the recomended_subtitle above will get data from index of component to display
   * <0><0/></0> mean get data index 0 of Trans component above = <Navlink> and <0/> get data index 0 from <Navlink> = {...something}
   */
    search: 'Cari Latihan',
    search_assessment: 'Cari Penilaian',
    recomended_message: 'Tidak ada cadangan kursus dan acara buat masa sekarang.'
  },

  warnings: {
    delete: 'Adakah anda pasti?'
  },

  workshop: {
    title: 'Bengkel Saya',
    subtitle: 'Cipta kursus atau acara langsung anda',
    new_course: 'Cipta Kursus Baru',
    new_event: 'Cipta Acara Langsung Baru',
    new_assessment: 'Cipta Penilaian Langsung Baru',
    courses_title: 'Kursus dan Acara Langsung Yang Telah Dicipta',
    courses_subtitle: 'Edit & Terbitkan kursus anda dan reka acara anda',
    tags_course: 'Kursus',
    tags_live: 'Acara Langsung',
    tags_assessment: 'Penilaian Langsung'
  },

  help_center: {
    sidebar: {
      title: 'Bagaimana Kami Boleh Bantu Anda?',
      back_to: 'Papan Pemuka'
    },
    menu: {
      help_center: 'Pusat Bantuan',
      whats_new: 'Apa Yang Baru',
      feedback: 'Maklum Balas',
      feedback_title: 'Hantar maklum balas ke sharelook',
      terms_and_conditions: 'Terma & Syarat',
      privacy_policy: 'Polisi Privasi',
      contact_us: 'Hubungi Kami'
    },
    get_started: {
      title: 'Bermula dengan share look',
      description: {
        main: 'KAMI TELAH MENGGABUNGKAN VIDEO LANGSUNG KE DALAM PEMBINA KURSUS YANG MUDAH DIGUNA',
        tagline:
      'Dengan sistem siaran langsung yang hakcipta dari ShareLook, anda dapat mendorong pembabitan, membenarkan pelajaran secara automatik dan meningkatkan perkongsian pengetahuan .'
      }
    },
    whats_new: {
      title: 'Bermula dengan share look',
      description: {
        main:
        'Adakah anda tahu bahawa dengan menggunakan cara pembelajaran bercerita, anda boleh cipta kursus dalam masa yang pendek dengan harga yang berpatutan?  Anda patut gabungkan pembina kursus ShareLook dengan bakat anda. Kami boleh ajar anda "Bagaimana',
        tagline: ''
      }
    },
    create_workshop: 'Cara Membina Bengkel',
    create_course: 'Cara Mencipta Kursus',
    create_user: 'Cara Mencipta Pengguna',
    create_group: 'Cara Mencipta Kumpulan',
    create_webinar: 'Cara Membuat Persidangan Web',
    create_live_event: 'Bagaimana Membuat Acara Langsung',
    create_live_assessment: 'Cara Membuat Penilaian Langsung',
    create_live_on_mobile: 'Bagaimana Membuat Siaran Langsung Dari Telefon',
    personalize_profile: 'Bagaimana Membina Profil Anda',
    manage_group: 'Mengurus Kumpulan',
    report: 'Laporan',
    add_annotations: 'Bagaimana Tambah Anotasi / Menu Timbul',
    add_audio: 'Cara Masukkan Audio',
    add_header_and_footer: 'Cara Masukkan Pengepala dan Pengaki',
    add_image: 'Cara Masukkan Imej',
    add_quiz_content: 'Cara Masukkan Kandungan Kuiz',
    add_text_content: 'Cara Masukkan Kandungan Teks',
    add_user: 'Cara Menambah Pengguna',
    add_video: 'Cara Masukkan Video',
    clone_course: 'Cara Klon Kursus',
    find_live_broadcast: 'Bagaimana Cari Saluran Siaran Langsung',
    contact_us: {
      title: 'Hubungi Kami',
      subject_placeholder: 'Masukkan subjek*',
      content_placeholder: 'Isikan mesej*',
      subject_required: '*Subjek diperlukan',
      content_required: '*Mesej diperlukan',
      submit: 'Hantar',
      cancel: 'Batal',
      sent: 'Sudah Hantar'
    },
    feedback: {
      title: 'Hantar Maklum Balas ke sharelook',
      attach_title: 'Lampiran fail',
      choose: 'Pilih Fail',
      detail: 'Fail akan dikongsi dengan pasukan sokongan',
      content_placeholder: 'Masukkan Mesej*',
      content_required: '*Mesej Diperlukan',
      submit: 'Hantar',
      cancel: 'Batal',
      sent: 'Sudah Hantar'
    }
  },
  discussion: {
    join_discussion: 'Sertai dalam perbincangan'
  },
  notes: {
    title: 'Nota Saya',
    add_note: 'Tambah Nota Baru'
  }
}
